<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">{{ $t('checksheet.titleTable') }}</h2>
            </div>
            <div class="card">
                <div class="card__detail">
                    <div class="" v-if="items">
                        <div class="nodata" v-if="items.data && items.data.length == 0">
                            {{ $t('common.nodata') }}
                        </div>
                        <div class="list__box">
                            <div class="list__item" v-for="(item, index) in (items)">
                                <span class="col">
                                    <strong>{{ item.customer.agency }}</strong>
                                    {{ item.customer.address }}<br>
                                    Contratto: {{ item.contratto }}
                                </span> <span class="col">
                                    salvato il<br>
                                <strong>{{ item.data_salvataggio | formatDateTime }}</strong>
                                </span> <span class="col">
                                    <button class="btn" type="button" @click="open(item)" :disabled="loading">
                                        <span>{{ $t('common.open') }}</span>
                                    </button>&nbsp;
                                    <button class="btn" type="button" @click="remove(index)" :disabled="loading">
                                        <span>{{ $t('common.delete') }}</span>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    export default {
        name: 'checksheets-offline-saved',
        components: {},
        mounted() {
            this.updateData();
        },
        data() {
            return {
                'items': [],
                'loading': false,
                'name': 'checksheet'
            }
        },
        methods: {
            updateData() {
                this.loading = true;
                this.sync.tempData.getItems(this.name)
                    .then((data) => {
                        this.items = data;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            open(item) {
                this.sync.tempData.update(this.name, item);
                this.$router.push({ path: '/checksheet-wizard' });
            },
            remove(index) {
                if (confirm('Sicuri di voler eliminare la riga')) {
                    this.sync.tempData.removeItem(this.name, index)
                        .then(() => {
                        })
                        .finally(() => {
                            this.updateData();
                        })
                }
            }
        }
    }
</script>
<style lang="scss">
    @import './src/scss/variables';
    @import './src/scss/checksheet';

    .card {
        &__header {
            display: flex;
            justify-content: space-between;
            background: transparent;
            height: auto;
            padding: 0 0 15px 0;

            .card__header-link {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                background: $middle-green;
                padding: 10px 20px;
                transition: 300ms $ease-out-quint;

                .btn {
                    &-icon .bar,
                    &-label {
                        transition: 300ms $ease-out-quint;
                    }

                    &-icon {
                        display: block;
                        width: 20px;
                        height: 20px;
                        margin-right: 15px;
                        position: relative;

                        .bar {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            background: $white;
                            width: 15px;
                            height: 4px;
                            transform: translate(-50%, -50%);

                            &:last-of-type {
                                transform: translate(-50%, -50%) rotate(90deg);
                            }
                        }
                    }

                    &-label {
                        display: block;
                        font-weight: 700;
                        font-size: 0.8em;
                        color: $white;
                        text-transform: uppercase;
                    }
                }

                &:hover {
                    background: $white;

                    .btn {
                        &-icon .bar {
                            background: $middle-green;
                        }

                        &-label {
                            color: $middle-green;
                        }
                    }
                }
            }
        }
    }

    .customers__list {
        display: flex;
        flex-direction: column;

        .customer {
            padding: 15px 10px;
            position: relative;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                background: $middle-green;
                width: 100%;
                height: 100%;
                z-index: 1;
                transform: scaleY(0);
                transform-origin: center bottom;
                transition: 600ms $ease-out-quint;
            }

            &__agency,
            &__referent {
                position: relative;
                z-index: 2;
                transition: 600ms $ease-out-quint;
            }

            &__agency {
                display: block;
                width: 100%;
                font-size: 1.5em;
                font-weight: 300;
                padding-bottom: 7px;
            }

            &__referent {
                font-size: 0.7em;
                text-transform: uppercase;
                color: $gray;

                strong {
                    font-weight: 700;
                }
            }

            &:nth-of-type(even) {
                background: rgba($gray, 0.05);
            }

            &:hover {
                .customer__agency,
                .customer__referent {
                    color: $white;
                }

                &:before {
                    transform: scaleY(1);
                    transform-origin: center top;
                }
            }
        }
    }
</style>
